export const SpaceOpsFlags = {
  BillingPaymentsInvoicesSubcriptions: 'space-ops.tab-subscription-invoices',
  BillingPaymentsUciPaymentRefactor: 'space-ops.uci-payment-refactor',
  BillingPaymentsDownloadInvoice: 'space-ops.download-invoice',
  SpaceOpsCancelSubscriptionAndUci: 'space-ops.cancel-sub-and-uci',
  VisitorManagementBufferTime: 'space-ops.visitor-management-buffer-time',
  VisitorManagementDateRangeMax: 'space-ops.date-range-max',
  VisitorManagementICSEmail: 'space-ops.visitor-management-ics',
  WorkOrdersPDF: 'space-ops.work-orders-pdf',
  EuPaymentCompliance: 'space-ops.eu-payment-compliance',
  PaymentSubmitOnBehalfOfExclusivity:
    'space-ops.payment-submit-on-behalf-exclusivity',
  FlatfileUpgradeToPlatform: 'space-ops.flatfile-upgrade-to-platform',
  WorkOrdersServiceRequestInvoicingOptions:
    'space-ops.work-orders-service-requests-invoicing',
  WorkOrdersPaymentsManagedExternally:
    'space-ops.work-orders-payments-managed-externally',
  VisitorManagementFloorSync: 'space-ops.visitor-management-floor-sync',
  VisitorManagementIGSRefactor: 'space-ops.visitor-management-igs-refactor',
  EnableServiceRequestTaskTime: 'space-ops.work-orders-service-requests-hours',
  WorkOrderSpecificTeamWorkflowTarget:
    'space-ops.work-orders-specific-team-workflow-targeting',
  WorkOrderCommentNotificationEmail:
    'space-ops.work-order-comment-notification.email',
  EnableBillingProductServicesCRUD: 'space-ops.billing-product-services-CRUD',
  GenerateServiceRequestFromPreventiveMaintenanceTask:
    'space-ops.work-orders-generate-service-request-from-preventive-maintenance-task',
  PMTaskAutoExpiration: 'space-ops.work-orders-pm-task-auto-expiration',
  ServiceRequestChargeOverride: 'space-ops.service-request-charge-override',
  ProductsAndServices: 'squad-billing-and-payments.products-and-services',
  PaymentFeatureV2: 'squad-billing-and-payments.payment-feature-v2',
  ChargesInvoice: 'squad-billing-and-payments.charges-invoice-v1',
  PaymentSettings: 'squad-billing-and-payments.payment-settings',
  YardiChargeCode: 'squad-billing-and-payments.yardi-charge-code-sync',
  AutopaymentFailureEmail:
    'squad-billing-and-payments.autopayment-failure-email',
  Credits: 'squad-billing-and-payments.credits',
  CreditBundlesInCharges: 'squad-billing-and-payments.credit-bundles-in-charge',
  ProductsInContent: 'squad-billing-and-payments.products-in-content',
  SubscriptionsInContent: 'squad-billing-and-payments.subscriptions-in-content',
  Exceptions: 'squad-billing-and-payments.exceptions',
  InvoiceDisabling: 'squad-billing-and-payments.invoice-disabling',
  RemovePaymentAccounts: 'squad-billing-and-payments.remove-payment-accounts',
  ProductsWithCredits: 'squad-billing-and-payments.products-with-credit-price',
  ChargeBillingReports: 'squad-billing-and-payments.billing-reports',
  ManualBillingReports: 'squad-billing-and-payments.manual-billing-reports',
  ApplePay: 'squad-billing-and-payments.apple-pay',
  PriceOnCard: 'squad-billing-and-payments.price-on-card',
  AutopaymentInContent: 'squad-billing-and-payments.autopayment-in-content',
  WorkOrderMobileEquipment: 'work-orders.admin-mobile-equipment',
  DataImporter: 'work-orders.data-importer',
  ImporterConverter: 'work-orders.importer-converter',
  WorkOrdersSuperConverter: 'work-orders.super-converter',
  InteractiveStepsCreate: 'work-orders.interactive-steps-create',
  InteractiveStepsDetails: 'work-orders.interactive-steps-details',
  InteractiveStepsExecute: 'work-orders.interactive-steps-execute',
  WorkOrderTenantSurveys: 'work-orders.tenant-survey',
  WorkOrdersAuditLogs: 'work-order.audit-logs',
  WorkOrderComments: 'work-order.comments',
  WorkOrderCommentsMobile: 'work-order.comments-mobile',
  WorkOrdersOnlyDisplayKnownFilters:
    'work-order.only-display-allowed-statuses-on-filter',
  WorkOrdersDisplayEscalationFilter: 'work-order.display-escalation-filter',
  WorkOrdersConfigurableNotifications: 'work-order-configurable-notifications',
  useNewAlertModalDesign: 'squad-work-order.new-alert-modal',
  WorkOrderOotbConfigurationUpdate:
    'squad-work-order.ootb-configuration-update',
  RiseMigrationAutoSetup:
    'platform-application-services.rise-migration-option-for-auto-setup',
  ChangeParent: 'platform-application-services.change-parent',
  SyncJoinRules: 'platform-application-services.sync-join-rules',
  LookerTimezoneParams: 'platform-application-services.looker_timezone_params',
  CESAutoSetup: 'platform-application-services.ces-option-for-auto-setup',
  RiseMigrationExportTenants:
    'platform-application-services.rise-migration-migrate-tenants',
  RiseMigrationAddRandomSuffix:
    'platform-application-services.rise-migration-add-random-suffix',
  EventAnalyticsLookerReport:
    'platform-application-services.event-analytics-looker-report',
  TeamsBulkAddUsers: 'platform-application-services.teams-bulk-add-users',
  TenantManagement: 'workorders.activate.tenant.managment',
  TenantManagementTenantImport:
    'workorders.activate.tenant.management-import.tenants',
  TenantManagementHideButtons:
    'workorders.activate.tenant.management-hide.tenant.buttons',
  TenantManagementAddTenantsUI:
    'workorders.activate.tenant.management.add-tenants-ui',
  UseParamWhiteLabelIdForPushNotification:
    'workorders.push-notifications.use-param-white-label-id',
  NotificationsBatchRestore: 'workorders.notifications.batch-restore',
  NotificationsCrudStrategyV2: 'workorders.notifications.crud-strategy.v2',
  WorkordersMaintainSettingsConfigurations:
    'workorders.maintain-settings-configurations',
  ScheduleServiceRequestDueDate: 'space-ops.schedule-service-request-due-date',
  ServiceRequestReminderWorkflowRule:
    'space-ops.service-request-reminder-workflow-rule',
  SpaceOpsCurrencyExpansion: 'space-ops.currency-expansion',
  BpMarkupChargeCode: 'space-ops.bp-markup-charge-code',
  BpAdminFeeChargeCode: 'space-ops.bp-admin-fee-charge-code',
  WorkOrdersServiceRequestTargetTimes: 'space-ops.wo-sr-target-times',
  BulkPaidInvoices: 'space-ops-2.bulk-paid-invoices',
  SpaceOpsModuleRoles: 'space-ops.module-roles',
  BuildingManagementTenantRoles: 'space-ops-2.building-management-tenant-roles',
  SpaceOpsPmBulkActions: 'space-ops-pm-bulk-actions',
  SpaceOpsSrBulkActions: 'space-ops-sr-bulk-actions',
  SrPmEmailSubjectChange: 'space-ops.sr-pm-email-subject-change',
  InspectionSrPrefillSync: 'inspection-sr-auto-sync',
  Inspections: 'activate-inspections',
  InspectionsAdminDashboard: 'activate-inspections-admin-dashboard',
  InspectionsServiceBasedReports: 'space-ops.inspections-service-based-reports',
  InspectionsWorkOrderIntegration:
    'space-ops.inspections-work-order-integration',
  InspectionsTemplateLibrary: 'activate-inspections-template-library',
  InspectionsTemplateCustomizeReorder:
    'activate-inspections-template-customize-reorder',
  InspectionsTemplateCustomizeRevertAll:
    'activate-inspections-template-customize-revert-all',
  InspectionsAddFromPhotoGallery: 'inspections-add-from-photo-gallery',
  MultiBuildingMobileView: 'multi-building-mobile-view',
  WoEndpointsAuth: 'wo-endpoints-auth',
  BulkChannelModules: 'space-ops.bulk-channel-modules',
  // Rogue flags
  SpaceOpsProductCatalogTableFilters: 'space-ops-product-catalog-table-filters',
  SpaceOpsSkipValidatedPassRotation: 'space-ops.skip-validated-pass-rotation',
  SpaceOpsStreamSrCommentReminderEventType:
    'space-ops.stream.sr-comment-reminder-event-type',
  SpaceOpsVisitorManagementPrintCompanyOnPass:
    'space-ops.visitor-management-print-company-on-pass',
  WorkOrderShowViolationTime: 'work-order.show-violation-time',
  // Rogue flags end

  SpaceOpsDeprecatedPaymentAccounts: 'space-ops.tenant-suite-optimized-loading', // borrow this temp ff
} as const;
